module.exports = __webpack_public_path__ + "img/tm_cheering.facbe7aa.png";